import React, { useEffect } from 'react';

import { MdRefresh, MdRemoveShoppingCart } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearCart, setCartOpen } from '../../../store/slices/cartSlice';
import { getNetTotal } from '../../../utils/formatters';
import ClassicCartItem from './ClassicCartItem';

const ClassicShoppingCart = ({ isFromCheckoutPage }) => {
    const cartItems = useSelector((state) => state.cartSlice.cartItems);
    const isStandAlone = useSelector((state) => state.cartSlice.isStandAlone);
    const cartTotal = useSelector((state) => state.cartSlice.total);
    const totalDiscount = useSelector((state) => state.cartSlice.totalDiscount);
    const shippingFee = useSelector((state) => state.settingsSlice.settings.defaultShippingFee);
    const isDeleting = useSelector((state) => state.cartSlice.loading.deleting);
    const cartIsFetchingData = useSelector((state) => state.cartSlice.loading.fetching);
    const dispatch = useDispatch();
    const router = useNavigate();

    const checkout = () => {
        dispatch(setCartOpen(false));
        router.push('/checkout');
    };

    const clearCartAction = () => {
        dispatch(clearCart());
    };

    return (
        <div>
            <div className={`flex flex-col ${cartIsFetchingData ? 'opacity-50' : ''}`}>
                {isDeleting && <p className="text-brand-merino">Updating cart...</p>}
                <div className='grid grid-cols-2 gap-2'>
                    <div className='max-h-32 overflow-y-auto pb-2'>
                        {cartItems.map((item) => (
                            <ClassicCartItem key={item.inventoryId} cartItem={item} />
                        ))}
                    </div>

                    <div className='pl-4 pt-4'>
                        <div className="text-right w-full">
                            <div className="flex justify-between">
                                <span className="text-sm">Products Total (LKR)</span>
                                <span className="text-lg">{cartTotal}</span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-sm">Shipping Total (LKR)</span>
                                <span className="text-lg">
                                    {parseFloat(cartTotal) <= 5000 ? shippingFee?.toFixed(2) : '0.00'}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-sm">Discount (LKR)</span>
                                <span className="text-lg">
                                    -{totalDiscount ? parseInt(totalDiscount).toFixed(2) : '0.00'}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-sm">Net Total (LKR)</span>
                                <span className="text-lg">{getNetTotal(cartTotal, shippingFee, totalDiscount).toFixed(2)}</span>
                            </div>
                        </div>

                        {cartItems.length > 0 && (
                            <button
                                className="px-4 py-2 bg-red-600 text-white rounded text-sm gap-1 hover:opacity-90 right-1/4"
                                onClick={clearCartAction}
                            >
                                <MdRemoveShoppingCart />
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div className="text-center mt-10">{cartIsFetchingData && <div className="spinner"></div>}</div>
        </div>
    );
};

export default ClassicShoppingCart;
